import Immutable from "immutable";

// import api from '../../lib/api';

// ------------------------------------
// Actions
// ------------------------------------

export const INITIALIZE = "@app/INITIALIZE";
export const WINDOW_SCROLL = "@app/WINDOW_SCROLL";
export const WINDOW_RESIZE = "@app/WINDOW_RESIZE";
export const DATALAYER_EVENT = "@app/DATALAYER_EVENT";
export const HYDRATE_AB_TESTS = "@app/HYDRATE_AB_TESTS";

// ------------------------------------
// Action generators
// ------------------------------------

export const pushDataLayerEvent = e => {
  if (window.dataLayer) {
    window.dataLayer.push(e);
  }
  return {
    type: DATALAYER_EVENT,
    payload: e
  };
};

export const onWindowScroll = () => ({
  type: WINDOW_SCROLL,
  payload: {
    windowScrollY: window.scrollY,
    windowScrollX: window.scrollX
  }
});

export const onWindowResize = () => ({
  type: WINDOW_RESIZE,
  payload: {
    windowHeight: window.innerHeight,
    windowWidth: window.innerWidth,
    isMobileView: window.innerWidth <= 1080
  }
});

// ------------------------------------
// Default State
// ------------------------------------

const State = Immutable.Record({
  hasInitialized: false,
  windowScrollY: window.scrollY,
  windowScrollX: window.scrollX,
  windowHeight: window.innerHeight,
  windowWidth: window.innerWidth,
  isMobileView: window.innerWidth <= 1080,
  abTests: Immutable.Map()
});

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [HYDRATE_AB_TESTS]: (state, { payload }) => state.set("abTests", Immutable.fromJS(payload)),
  [WINDOW_SCROLL]: (state, { payload }) =>
    state.set("windowScrollY", payload.windowScrollY).set("windowScrollX", payload.windowScrollX),
  [WINDOW_RESIZE]: (state, { payload }) =>
    state
      .set("windowHeight", payload.windowHeight)
      .set("windowWidth", payload.windowWidth)
      .set("isMobileView", payload.isMobileView)
};
// ------------------------------------
// Reducer
// ------------------------------------

export default function reducer(state = new State(), action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
